import { replaceConfiguration, 
// setCfgNotice,
setProblemDetails, setSessionId, } from "../reducers/actions";
import { getSyncState } from "../reducers/selectors";
export function handleCfgStateResponse(response) {
    return (dispatch, getState) => {
        var _a;
        if (!response) {
            const title = "No response from backend, session expired?";
            console.error(title);
            dispatch(setProblemDetails({ title }));
        }
        // set configuration state
        if ("id" in response) {
            const configuration = response;
            dispatch(setSessionId(configuration.id));
            // remove null objects
            const objects = (_a = configuration.objects) === null || _a === void 0 ? void 0 : _a.filter(Boolean);
            // TODO: should we clean up selectors here? in case of reset?
            dispatch(replaceConfiguration(Object.assign(Object.assign({}, configuration), { objects }), getSyncState(getState())));
        }
        else {
            const problem = response;
            dispatch(setProblemDetails(problem));
        }
    };
}
//# sourceMappingURL=handleCfgStateResponse.js.map